export const getEntityHeaderStyles = () => ({
    header: {
        container: {
            display: 'flex',
            alignItems: 'center',
            mb: 2
        },
        icon: {
            color: 'blue',
            marginRight: 1
        },
        title: {
            fontWeight: 'bold'
        }
    },
});